(function () {
    'use strict';
    if (!localStorage.getItem('och-relevant-user')) {
        $('#modal').modal({
            backdrop: 'static'
        })
    }
    $('#modal-trigger-relevant').on('click', function (e) {
        e.preventDefault();
        $('#modal').modal('hide')
        localStorage.setItem('och-relevant-user', 'true')
    })

}());
